const isMEIZU = (): boolean => {
  const ua = navigator.userAgent;
  const m = ua.match(';s?([^;]+?)s?(Build)?/') || [];
  const model = m[1];
  const meizuReg = /\b[M]\d{3}\b/;
  const meizuNewReg = /\b[M][X]\d{1}\b/;
  if (meizuReg.test(model)) {
    return true;
  } else {
    if (meizuNewReg.test(model)) {
      return true;
    } else {
      return false;
    }
  }
};

export default isMEIZU;
